<template>
  <div class="radiobutton" v-bind:class="{ disabled: isDisabled }">
  	<input
      type="radio"
      v-on:change="onChange(filter)"
      v-bind:id="id"
      v-bind:name="name"
      v-bind:value="value"
      v-bind:checked="checked"
      v-bind:disabled="isDisabled"
    />
  	<label v-bind:class="[filter.id, true, ischecked ? 'checked' : '']" v-bind:for="id">
      <img class="icon default" :src="iconPath + filter.id + '_02.svg'"/>
      <img class="icon disabled" :src="iconPath + filter.id + '_01.svg'"/>
      <img class="icon active" :src="iconPath + filter.id + '_03.svg'"/>
      <div class="label">
        <div class="text">{{ id }}<div v-if="!isDisabled" class="tooltop" :data-tooltip="filter.tooltip">i</div></div>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: 'radiobutton',
  props: ['id', 'name', 'value', 'action', 'checked', 'isDisabled', 'filter'],
  mounted() {
    this.ischecked = this.checked;
  },
  methods: {
    	onChange(filter) {
      this.$emit('setFilter', filter);
    	},
  },
  data() {
    return {
      ischecked: false,
      iconPath: 'assets/icons/',
    };
  },
};
</script>


<style scoped lang="scss">
.radiobutton {
  position: relative;
  display: block;
  padding: 12px 0;

  .text {
    display: inline;
  }

  &.disabled {
    label:hover .active {
      opacity: 0;
    }
  }

  label {
    position: relative;
    display: block;
    transition: color .5s;
    padding-left: 45px;
    min-height: 34px;
    display: flex;
    align-items: center;
    font-size: 14px;

    &:hover {
      .active {
        opacity: 1;
      }
    }
  }

  input {
    position: absolute;
    opacity: 0;

    &:hover,
    &:checked {
      + * {
        &:before {
          background-color: $color-brand;
        }
      }
    }

    &:disabled {
      + * {
        color: $color-grey;
        &:before {
            border-color: $color-grey;
        }
      }
    }
  }

  .icon {
    position: absolute;
    top: 50%;
    left: 0;
    width: 40px;
    height: 35px;
    transform: translate(0, -50%);
    opacity: 0;

    @extend .animateOpacity;
  }

  input[type="radio"]:checked+label > .active {
    opacity: 1;
  }

  input[type="radio"]:disabled+label > .disabled {
    opacity: 1;
  }

  .default {
    opacity: 1;
  }

  .tooltop {
    left: 4px;
  }

}
</style>
